import template from './fiscal-sales-zreport.html';
import controller from './fiscal-sales-zreport.controller';
import './fiscal-sales-zreport.scss';

let FiscalSalesZreportComponent = {
  bindings: {},
  template,
  controller
};

export default FiscalSalesZreportComponent;



// WEBPACK FOOTER //
// ./src/app/pages/fiscal-sales-zreport/fiscal-sales-zreport.component.js